import * as React from 'react';
import * as styles from './style.css';

export const AdvertiseList = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
